module.exports = __webpack_public_path__ + "static/media/tmp-lady.aacc0f4d.png";